

export const toFormattedNumber = (number: number) =>
  new Intl.NumberFormat('vi-VN').format(number ?? 0);